<template>
  <div id='' class='gPageBorder' v-loading=loading>

    <el-button type='primary' @click='showInput' class='gSgLeftBtn'>{{$t('app_newapptype')}}</el-button>
  
    <div id=''>
      <el-table
        class='gTopMg'
        @row-click='cellClick'
        :data="tableData"
        border
        @sort-change='sortChange'
        style="width: 100%">
        <el-table-column
          header-align='center'
          align='center'
          prop="appClassifyName"
          sortable="custom"
          :label="$t('app_typeName')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width=''
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <!-- <el-button type=text @click='edit(scope.row)'>{{$t('app_edit')}}</el-button>
            <el-button type=text @click='del(scope.row)'>{{$t('app_del')}}</el-button> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button type='text' @click='edit(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' @click='del(scope.row)'><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <el-dialog :title="$t('app_appType')" class='gDia' v-model="dialogFormVisible" @open=open @close='close'>
      <div>
        <table style='width:100%;' class='gDiaTable'>
          <tr>
            <td style='width:25%;text-align:center;'>{{$t('app_typeName')}}：</td>
            <td><el-input style='' v-model='name'></el-input></td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure">{{$t('app_sure')}}</el-button>
      </div>
    </el-dialog> -->

    <el-dialog class='gDia' :title="$t('app_appType')" v-model="dialogFormVisible" @open=open @close='close'>
      <div>
        <el-form>
          <el-form-item label-width='14.5%' :label="$t('app_typeName')">
            <el-input style='' v-model='name'></el-input>
          </el-form-item>
          <el-form-item label-width='14.5%'>
            <el-button type="" @click="cancelEdit">{{$t('app_cancel')}}</el-button>
            <el-button type="primary" @click="sure">{{$t('app_sure')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <div class="gPgDiv" >
      <el-pagination
        @current-change="pageSelect"
        @size-change="pageSized"
        class='gPg'
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<style>
</style>

<script>
  export default{
    data () {
      return {
        orderType: '',
        orderName: '',
        name: '',
        row: this.$gRow,
        index: 1,
        total: 0,
        dialogFormVisible: 0,
        tableData: [],
        loading: 0,
        editData: ''
      }
    },
    methods: {
      sortChange (vl) {
        
        switch (vl.prop) {
          case 'appClassifyName':
            this.orderName = '1'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList(this.index)
      },
      cancelEdit () {
         this.dialogFormVisible = false
      },
      edit (row) {
        this.editData = row
        this.dialogFormVisible = 1
      },
      del (row) {
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          // console.log(row)
          var id = row.appClassifyId
          this.loading = 1
          this.$delAppType(id, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList(this.index)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        })
        // console.log(row)
      },
      pageSelect (index) {
        this.getList(index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getList(this.index)
      },
      open () {
        if (this.editData) {
          // console.log(this.editData)
          this.name = this.editData.appClassifyName
        }
      },
      close () {
        // this.loading =0
        this.editData = ''
        this.name = ''
      },
      showInput () {
        this.dialogFormVisible = 1
      },
      newData () {
        var vl = this.name
        if (vl) {
          this.loading = 1
          this.$addAppType(vl, (res) => {
            this.loading = 0
            console.log(res)
            if (res.status === 200) {
              this.getList(this.index)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          this.dialogFormVisible = 0
        } else {
          this.$message.error(this.$t('app_inputAName'))
        }
      },
      editRqs () {
        var vl = this.name
        if (vl) {
          this.loading = 1
          this.$editAppType(this.editData.appClassifyId, vl, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList(this.index)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          this.dialogFormVisible = 0
        } else {
          this.$message.error(this.$t('app_inputAName'))
        } 
      },
      sure () { 
        if (this.editData) {
          // edit
          this.editRqs()
        } else {
          // new
          this.newData()
        }
      },
      getList (index) {
        this.loading = 1
        this.$appTypeList(this.$gRow, index, this.orderName, this.orderType, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            console.log('data', res.data)
            this.tableData = res.data
            this.total = res.total
            this.index = index
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      }
    },
    mounted () {
      this.getList(this.index)
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// appTypeManage.vue?8e7c91ce